export function isFulfilledPromise(p) {
    const promise = p;
    return (promise.status === 'fulfilled') && (promise.value !== undefined);
}
export function isRejectedPromise(p) {
    const promise = p;
    return promise.status === 'rejected';
}
/*
   The Promise.allSettled method is available in ES2020 but we were having issues when running tests
   possibly because RN uses babel after TS is compiled to JS. This is an implementation that is
   similar to the one implemented in:
   https://stackoverflow.com/questions/30569182/promise-allsettled-in-babel-es6-implementation#answer-39031032
 */
export function allSettled(promises) {
    const wrappedPromises = promises.map((p) => (Promise.resolve(p)
        .then((val) => ({ status: 'fulfilled', value: val }), (err) => ({ status: 'rejected', reason: err }))));
    return Promise.all(wrappedPromises);
}
//# sourceMappingURL=PromiseUtil.js.map